class MatchLeaguesController {
  constructor(
    MatchesFactory,
    LeaguesFactory,
    $rootScope,
    $filter,
    $state,
    ngDialog,
    Permissions,
    Levels
  ) {
    "ngInject";
    const vm = this;

    let $translate = $filter("translate");
    vm.levels = [
      { id: Levels.WHITE, name: "White" },
      { id: Levels.BLACK, name: "Black" },
      { id: Levels.BLUE, name: "Blue" },
      { id: Levels.RED, name: "Red" },
      { id: Levels.YELLOW, name: "Yellow" },
      { id: Levels.GREEN, name: "Green" },
    ];

    /* Load Matches dat */
    vm.$onInit = function () {
      $state.current.data.hideSidebar = true;
      vm.rootScope = $rootScope;
      vm.options = [
        { id: 1, name: "MATCH_LEAGUES" },
        { id: 2, name: "PLAYER_LEAGUES" },
        { id: 3, name: "MOVE_MATCH", permission: Permissions.MOVE_MATCH },
      ];
      vm.matchPlayers = [];
      vm.activeOption = 0;
      vm.matches = [];
      vm.matchLeagues = [];
      LeaguesFactory.getAll().then((response) => {
        vm.leagueGridOptions.data = response.data;
        reloadMatchData();
      });
      MatchesFactory.getAll().then((response) => {
        vm.matches = response.data;
      });
    };

    vm.hasPermission = (permission) => {
      return vm.rootScope.user.canDo(permission);
    };

    vm.selectOption = (option) => {
      vm.activeOption = option;
    };

    /* Edit Match Leagues */
    vm.leagueGridOptions = {
      enablePaginationControls: false,
      enableSorting: true,
      enableFiltering: true,
      columnDefs: [
        {
          field: "league_name",
          enableFiltering: true,
          name: $translate("LEAGUE_NAME"),
        },
        {
          field: "level",
          enableFiltering: true,
          name: $translate("LEVEL"),
          width: "100",
          cellTemplate: `<div class="ui-grid-cell-contents ui-grid-align-c">
			{{grid.appScope.vm.getLevelName(row.entity)}}
			</div>`,
        },
        {
          field: "type",
          enableFiltering: true,
          name: $translate("BOW_TYPE"),
          width: "100",
        },
        {
          field: "actions",
          enableFiltering: false,
          name: $translate("ACTIONS"),
          headerCellClass: "text-center",
          cellTemplate:
            "" +
            "<div " +
            'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
            '<div class="buttons">' +
            '<button class="btn btn-sm btn-success" translate ' +
            'ng-if="!grid.appScope.vm.isLeagueInMatch(row.entity.league_id)" ' +
            'ng-click="grid.appScope.vm.addLeague(row.entity.league_id)">CREATE</button> ' +
            '<button class="btn btn-sm btn-danger" translate ' +
            'ng-if="grid.appScope.vm.isLeagueInMatch(row.entity.league_id)" ' +
            'ng-click="grid.appScope.vm.removeLeague(row.entity.league_id)">DELETE</button> ' +
            "</div>" +
            "</div>",
          width: "150",
        },
      ],
      onRegisterApi: function (gridApi) {
        vm.leaguesGridApi = gridApi;
      },
    };
    vm.isLeagueInMatch = (leagueId) => {
      return vm.matchLeagues.find((matchLeague) => {
        return matchLeague.league_id === leagueId;
      });
    };
    vm.addLeague = (league_id) => {
      MatchesFactory.addLeague(vm.rootScope.currentMatchId, league_id).then(
        () => reloadMatchData()
      );
    };
    vm.removeLeague = (leagueId) => {
      ngDialog
        .openConfirm({
          template: "confirmTemplate",
          data: {
            message: $translate("CONFIRM_REMOVE_LEAGUE_FROM_MATCH"),
          },
        })
        .then(() => {
          MatchesFactory.removeLeague(
            vm.rootScope.currentMatchId,
            leagueId
          ).then((response) => {
            reloadMatchData();
          });
        });
    };
    vm.getLevelName = (league) => {
      return vm.levels.find((l) => l.id === league.level).name;
    };

    /* Player Leagues */
    vm.gridOptions = {
      enableSorting: true,
      paginationPageSizes: [50, 100, 150],
      paginationPageSize: 50,
      enableColumnMenus: false,
      enableFiltering: true,
      columnDefs: [
        {
          field: "AA",
          enableFiltering: false,
          displayName: "AA",
          width: "58",
          cellTemplate:
            "" +
            '<div class="ui-grid-cell-contents">{{grid.renderContainers.body.visibleRowCache.indexOf(row)+(grid.options.paginationPageSize*(grid.options.paginationCurrentPage-1))+1}}</div>',
        },
        {
          field: "playerName",
          enableFiltering: true,
          name: $translate("PLAYER_NAME"),
        },
        {
          field: "teamName",
          name: $translate("TEAM_NAME"),
          enableFiltering: false,
          width: "170",
        },
        {
          field: "leagueName",
          name: $translate("LEAGUE_NAME"),
          enableFiltering: false,
        },
        {
          field: "changeLeague",
          enableFiltering: false,
          name: $translate("UPDATE_PLAYER_LEAGUE"),
          headerCellClass: "text-center",
          cellTemplate:
            "" +
            "<div " +
            'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
            "<button " +
            'class="btn btn-sm info" ' +
            "translate " +
            'data-toggle="modal" ' +
            'ng-click="grid.appScope.vm.opelPlayerLeagueModal(row.entity.player_id)" ' +
            'data-target="#changePlayerLeagueModel">PICK</button></div>',
          width: "170",
        },
      ],
    };
    vm.opelPlayerLeagueModal = (playerId) => {
      vm.currentPlayerId = playerId;
      vm.selectedLeauge = null;
    };
    vm.updatePlayerLeague = () => {
      MatchesFactory.updatePlayerLeague(
        vm.rootScope.currentMatchId,
        vm.currentPlayerId,
        vm.selectedLeauge.league_id
      ).then((response) => {
        ngDialog.open({ template: "successTemplate" });
        reloadMatchData();
        vm.clearSelections();
      });
    };

    /* Move Leagues */
    vm.leaguesToMove = [];
    vm.newMatch = null;
    vm.moveLeagues = () => {
      let leagueIds = [];
      Object.entries(vm.leaguesToMove).forEach((entry) => {
        let key = entry[0];
        let value = entry[1];
        if (value) {
          leagueIds.push(key);
        }
      });
      if (leagueIds.length === 0) {
        return;
      }
      ngDialog
        .openConfirm({
          template: "confirmTemplate",
          data: {
            message: $translate("CONFIRM_MOVE_LEAGUES"),
          },
        })
        .then(() => {
          MatchesFactory.moveLeagues(
            vm.rootScope.currentMatchId,
            vm.newMatch.match_id,
            leagueIds
          ).then((response) => {
            ngDialog.open({ template: "successTemplate" });
            reloadMatchData();
          });
        });
    };

    function reloadMatchData() {
      MatchesFactory.getOne(vm.rootScope.currentMatchId, {
        include: "matchPlayers,matchLeagues",
      }).then((response) => {
        vm.gridOptions.data = response.data.matchPlayers;
        vm.matchLeagues = [];
        Object.entries(response.data.matchLeagues).forEach(([key, value]) => {
          vm.matchLeagues.push(value.league);
        });
        if (vm.leaguesGridApi) {
          vm.leaguesGridApi.core.refresh();
        }
      });
    }
  }
}

export default MatchLeaguesController;



// WEBPACK FOOTER //
// ./client/app/components/matches/matchProfile/matchLeagues/matchLeagues.controller.js